import { Module } from 'vuex'

interface LanguageStatisticsState {
  chartData: { labelChartData: string[]; languageStatisticsChartData: number[][]; maxTotal: number }
  chartSeries: any[]
  chartOptions: any
}

export const languageStatisticsModule = (): Module<LanguageStatisticsState, any> => {
  return {
    namespaced: true,
    state: {
      chartData: { labelChartData: [], languageStatisticsChartData: [], maxTotal: 0 },
      chartSeries: [],
      chartOptions: {}
    },
    mutations: {
      setChartData(
        state,
        chartData: { labelChartData: string[]; languageStatisticsChartData: number[][]; maxTotal: number }
      ) {
        state.chartData = chartData
      },
      setChartSeries(state, chartSeries: any[]) {
        state.chartSeries = chartSeries
      },
      setChartOptions(state, chartOptions: any) {
        state.chartOptions = chartOptions
      }
    },
    actions: {},
    getters: {
      chartData: state => state.chartData,
      chartSeries: state => state.chartSeries,
      chartOptions: state => state.chartOptions
    }
  }
}
